import { unreadCountScreenReaderOnlyText } from 'owa-locstrings/lib/strings/unreadcountscreenreaderonlytext.locstring.json';
import loc from 'owa-localize';
import { observer } from 'mobx-react-lite';
import { getGroupsStore } from 'owa-groups-shared-store';

import * as React from 'react';

const groupNodeStyles = require('./GroupUnreadCount.scss');

export interface GroupUnreadCountProps {
    groupId: string;
}

const GroupUnreadCount = observer(function GroupUnreadCount(props: GroupUnreadCountProps) {
    const groupsStore = getGroupsStore();
    const group = groupsStore.groups.get(props.groupId.toLowerCase());
    const unreadMessageCount = group ? group.unreadMessageCount : null;

    // check that count exists and is not equal to 0
    return unreadMessageCount ? (
        <span className={groupNodeStyles.unreadCount}>
            {unreadMessageCount}
            <span className="screenReaderOnly">
                {// for a treeitem, inner content that have aria-hidden=true are not hidden in IE
                // therefore we cannot hide the visual string and use a screenReaderOnly string that has the count
                loc(unreadCountScreenReaderOnlyText)}
            </span>
        </span>
    ) : null;
});
export default GroupUnreadCount;
